import { useReceiveAsset } from "../../Hooks/Features/InventoryDashboard/useReceiveAsset"
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import CommonImage from "../CommonCompo/CommonImage/CommonImage";
import { Calendar } from "primereact/calendar";

const ReceiveAssetForm = ({ onClose, editData, dropdownOpts, handleAssetDetails }) => {

  const { options, fieldValues, setFieldValues, handleReset, handleReceive, loader } = useReceiveAsset({ onClose, editData, dropdownOpts, handleAssetDetails });

  return (
    <div className="d-flex flex-wrap gap-2">
      <div className="w50">
        <div>Received By*</div>
        <Dropdown className="input-dd" options={options?.receive_by} value={fieldValues?.receive_by} onChange={(e) => setFieldValues((prev) => ({ ...prev, receive_by: e.target.value }))} filter filterInputAutoFocus optionLabel="assets_assignee_name" />
      </div>
      <div className="w45">
        <div>Received Date*</div>
        <Calendar className="input-dd inventory-assign-calendar" value={fieldValues?.returned_date} onChange={(e) => setFieldValues((prev) => ({ ...prev, returned_date: e.target.value }))} dateFormat="dd-mm-yy" />
      </div>
      <div className="w100 d-flex gap-2 align-items-center my-1">
        <div className="w20 d-flex align-items-center gap-2">
          <div>Is Exit?</div>
          <input type="checkbox" value={fieldValues?.is_exit} onChange={(e) => setFieldValues((prev) => ({ ...prev, is_exit: e.target.checked, is_replace: false }))} checked={fieldValues?.is_exit} />
        </div>
        {!fieldValues?.is_exit && <div className="w20 d-flex align-items-center gap-2">
          <div>Is Replace?</div>
          <input type="checkbox" value={fieldValues?.is_replace} onChange={(e) => setFieldValues((prev) => ({ ...prev, is_replace: e.target.checked, is_exit: false }))} checked={fieldValues?.is_replace} />
        </div>}
      </div>
      {!fieldValues?.is_replace ? <div className="w100">
        <div>Receive Other Assets?</div>
        <MultiSelect className="inventory-multiselect" style={{ height: "auto" }} display="chip" options={options?.other_assets} filter filterInputAutoFocus optionLabel="asset_unique_id" value={fieldValues?.other_assets} onChange={(e) => setFieldValues((prev) => ({ ...prev, other_assets: e.target.value }))}/>
      </div> :
        <div className="notes w100 mt-0">
          Only the parent asset will be replaced by the selected asset.
        </div>
      }
      {fieldValues?.is_replace && <div className="w100">
        <div>Replace asset by*</div>
        <Dropdown className="input-dd" options={options?.assets_details} value={fieldValues?.replace_asset} onChange={(e) => setFieldValues((prev) => ({ ...prev, replace_asset: e.target.value }))} filter filterInputAutoFocus optionLabel="asset_unique_id" />
      </div>}
      <div className="w100">
        <div>Receive Remark*</div>
        <input type="text" className="w100 input-dd" style={{ resize: "none" }} value={fieldValues?.remark} onChange={(e) => setFieldValues((prev) => ({ ...prev, remark: e.target.value }))} />
      </div>
      <div className="w100">
        <div>Upload Return Media of <span className="fw-bold">{editData?.asset_unique_id}</span></div>
        <CommonImage type="upload" selectedImages={fieldValues?.media} setSelectedImages={(val) => setFieldValues((prev) => ({ ...prev, media: val }))} />
      </div>
      {!fieldValues?.is_replace && fieldValues?.other_assets?.length > 0 && fieldValues?.other_assets?.map((asset, index) => (
        <div className="w100" key={index}>
          <div>Upload Return Media for <span className="fw-bold">{asset?.asset_unique_id}</span></div>
          <CommonImage type="upload" selectedImages={fieldValues?.[asset?.asset_unique_id] || []} setSelectedImages={(val) => setFieldValues((prev) => ({ ...prev, [asset?.asset_unique_id]: val }))} />
        </div>
      ))}
      <div className="text-right w100">
        <button className="button btn-default" onClick={() => { onClose(); handleReset(); }}>Cancel</button>
        {loader ?
          <button className="button btn-primary w15">
            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
              <span className="sr-only"></span>
            </div>
          </button> :
          <button className="button btn-primary w15" onClick={() => { handleReceive() }}>Receive</button>
        }
      </div>
    </div>
  )
}

export default ReceiveAssetForm